import store, { Filter, Quickfilter } from '../store';

export const filterParams = {
  pkfonds: 'facet_fondsfilter:pkfonds',
  funds: 'facet_cmsfilter:fonds',
  top_downloads: 'facet_cmsfilter:top_downloads',
  downloads: 'facet_kategorie:downloads',
  formular: 'facet_celum_assetKind:Formular',
  yield_data: 'facet_celum_topicSelection:Ertragsdaten Union Investment Gruppe',
  taxes_data: 'facet_celum_topicSelection:Steuern',
};

// The following filters need to be available via url param
export const quickfilters = {
  // Special funds filter with different result mode
  FUNDS: {
    urlValue: 'vku',
    label: 'Fonds',
    filters: [{ value: filterParams.funds }],
  },
  TOP_DOWNLOADS: {
    urlValue: 'top-downloads',
    label: 'Top-Downloads',
    filters: [{ value: filterParams.top_downloads }],
  },
  FORMS_AND_SERVICE: {
    urlValue: 'formulare-service',
    label: 'Formulare & Service',
    filters: [{ value: filterParams.formular }],
  },
  TAXES_AND_INCOME: {
    urlValue: 'steuern-ertraege',
    label: 'Steuern & Erträge',
    filters: [
      { value: filterParams.taxes_data },
      { value: filterParams.yield_data },
    ],
  },
};

export function getSpecialQuickfilter(
  property: string,
  value: string
): Quickfilter {
  return Object.values(quickfilters).find((el) => el[property] === value);
}

/**
 * Passing trough filter values of each quickfilter and checking is
 * some of them match with current selected filters
 */
export function isQuickfilterActive(quickfilterFilters: Filter[]) {
  if (quickfilterFilters.length > 0) {
    return quickfilterFilters.every(
      (filter) =>
        store.state.selectedFilters.filter(
          (selectedFilter) => selectedFilter.value === filter.value
        ).length
    );
  }
  return false;
}
